import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { apiPostRequest, apiDeleteRequest, apiGetRequest } from "../../../helpers/Requests";
import { toast } from "react-toastify";
import { AiOutlinePlus } from "react-icons/ai";
import { LoginContext } from "../../../helpers/LoginContext";
import SideBar from "../../../components/common/SideBar/SideBarNew";
import PaginationComponent from "../../../components/common/Pagination/index";
import { getPaginationObj } from "../../../Utils/utils";
import {
  emptyPaginationObj,
  POLICIES_LIST_LIMIT,
  SORT_TYPE,
} from "../../../Constants/constant";
import Header from "../../../components/common/Header/Header";
import { uploadFilesOnVapour } from "../../../Utils/uploadFileOnS3";
import { URL_FEEDBACK_DELETE, URL_FEEDBACK_MANAGERS_LIST, URL_FEEDBACK_WORKER_LIST } from "store/services/URL";

import FeedbackTable from './components/FeedbackTable';
import FeedbackFilters from './components/FeedbackFilters';
import AddFeedbackModal from './Modals/AddFeedbackModal';
import ViewFeedbackModal from './Modals/ViewFeedbackModal';
import DeleteFeedbackModal from './Modals/DeleteFeedbackModal';
import EditFeedbackModal from './Modals/EditFeedbackModal';
import moment from "moment";

const Feedback = (props) => {
  const { sideBarPadding, isUserGracePeriodOver } = useContext(LoginContext);
  const { getFeedbackList, feedbackObj, loading } = props;

  const [isOpen, setisOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState(null);
  const [page, setPage] = useState(1);
  const [feedbacks, setFeedbacks] = useState([]);
  const [search, setSearch] = useState(null);
  const [paginationObj, setPaginationObj] = useState(emptyPaginationObj);
  const [sortBy, setSortBy] = useState(paginationObj.sort_field);
  const [sortDescending, setSortDescending] = useState(
    paginationObj.sort_order === SORT_TYPE.DESC ? true : false
  );
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [feedbackToDelete, setFeedbackToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [feedbackToEdit, setFeedbackToEdit] = useState(null);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedParticipant, setSelectedParticipant] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedFromDate, setSelectedFromDate] = useState(null);


  const [participantOptions, setParticipantOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [loadingParticipants, setLoadingParticipants] = useState(false);
  const [loadingManagers, setLoadingManagers] = useState(false);
  const [selectedWorker, setSelectedWorker] = useState(null);

  const statusOptions = [
    { value: 'pending', label: 'Pending' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'completed', label: 'Completed' }
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      attachments: [],
      email: [],
      participants: [],
      workers: [],
    }
  });
  const [workersList, setWorkersList] = useState([]);
   const [loadingWorkers, setLoadingWorkers] = useState(false);
  useEffect(() => {
    fetchParticipantsList();
    fetchManagersList();
    fetchAllWorkersList();
  }, []);

    const fetchAllWorkersList = async () => {
    setLoadingWorkers(true)
      try {
        const response = await apiGetRequest(URL_FEEDBACK_WORKER_LIST);

        if (response?.status === 200) {
          const formattedWorkers = response?.data?.data?.map((worker) => ({
            id: worker?.id,
            value: worker?.uuid || worker?.id,
            label: `${worker?.first_name || ''} ${worker?.last_name || ''}`.trim() || worker?.name,
          })).sort((a, b) => a.label.localeCompare(b.label));
          setWorkersList(formattedWorkers || []);
        }
      } catch (error) {
        console.error("Error fetching all workers:", error);
        setWorkersList([]);
      }
      finally {
        setLoadingWorkers(false)
      }
    };
  const fetchParticipantsList = async () => {
    setLoadingParticipants(true);
    try {
      const response = await apiGetRequest("/sp/feedback/participants_list");
      if (response?.status === 200) {
        const formattedParticipants =response?.data?.data?.map((participant) => ({
            id: participant?.id,
          value: participant?.uuid || '',
          label: participant?.first_name + " " + participant?.last_name || '',
        })).sort((a, b) => a.label.localeCompare(b.label));
        setParticipantOptions(formattedParticipants || []);
      }
    } catch (error) {
      setParticipantOptions([]);
    } finally {
      setLoadingParticipants(false);
    }
  };

  const fetchManagersList = async () => {
    setLoadingManagers(true);
    try {
      const response = await apiGetRequest(URL_FEEDBACK_MANAGERS_LIST);
      if (response?.status === 200) {
        const formattedManagers =  response?.data?.data?.map(manager => ({
        id: manager?.user?.id,
        uuid: manager?.user?.uuid,
          value: manager?.user?.email || manager?.user?.id,
          label: `${manager?.user?.name}`,
        })).sort((a, b) => a.label.localeCompare(b.label));

        setManagerOptions(formattedManagers || []);
      }
    } catch (error) {
      setManagerOptions([]);
    } finally {
      setLoadingManagers(false);
    }
  };

  useEffect(() => {
    if (feedbackObj && "feedback_and_complaints" in feedbackObj) {
      setFeedbacks(feedbackObj.feedback_and_complaints);
      setPaginationObj(
        getPaginationObj(
          feedbackObj.feedback_and_complaints,
          feedbackObj.query_params
        )
      );
    } else if (feedbackObj && "submitted_forms" in feedbackObj) {
      setFeedbacks(feedbackObj.submitted_forms);
      setPaginationObj(
        getPaginationObj(feedbackObj.submitted_forms, feedbackObj.query_params)
      );
    }
  }, [feedbackObj]);

  useEffect(() => {
    setSortBy(paginationObj.sort_field ? paginationObj.sort_field : null);
    if (paginationObj.sort_order)
      setSortDescending(
        paginationObj.sort_order
          ? paginationObj.sort_order === SORT_TYPE.DESC
            ? true
            : false
          : false
      );
  }, [paginationObj]);

  useEffect(() => {
    const obj = { page: paginationObj.page };
    if (sortBy) {
      Object.assign(obj, {
        sort_field: paginationObj.sort_field ? paginationObj.sort_field : null,
        sort_order:
          paginationObj.sort_order === SORT_TYPE.DESC
            ? SORT_TYPE.DESC
            : SORT_TYPE.ASC,

      });
    }
    if (
      !search &&
      parseInt(feedbackObj?.query_params?.page) !== paginationObj.page
    ) {
      fetchWithFilters(obj);
    }
  }, [paginationObj.page]);

  useEffect(() => {
    handleFetch({ search: search });

  }, []);

  useEffect(() => {
    if (search === null) return;
    const timeOutId = setTimeout(
      () => handleFetch({ search: search }),
      600
    );
    return () => clearTimeout(timeOutId);
  }, [search]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [paginationObj.page]);

  const getFeedback = async (filters) => {
    if (!filters || filters === undefined) {
      Object.assign((filters = {}), {
        page: paginationObj.page,
      });
    }
    Object.assign(filters, { per_page: POLICIES_LIST_LIMIT });
    Object.assign(filters, { type: "feedback" });
    getFeedbackList(filters);
  };

  const handleFetch = (obj = {}) => {
    if (paginationObj.page && !obj.hasOwnProperty("page")) {
      Object.assign(obj, { page: paginationObj.page });
    }

    if (paginationObj.sort_field && !obj.hasOwnProperty("sort_field")) {
      Object.assign(obj, {
        sort_field: paginationObj.sort_field,
        sort_order: paginationObj.sort_order === SORT_TYPE.DESC ? SORT_TYPE.DESC : SORT_TYPE.ASC,
      });
    }

    if (obj.hasOwnProperty("search")) {
      Object.assign(obj, { page: 1, search: obj.search });
    } else if (paginationObj.search && !obj.hasOwnProperty("search")) {
      Object.assign(obj, { search: paginationObj.search });
    }

    getFeedback({ ...obj });
  };

  const dataSubmitHandler = async (data) => {
    setIsSubmitting(true);
    try {
      let uploadedFiles = [];
      if (data?.attachments && data?.attachments?.length > 0) {
        uploadedFiles = await uploadFilesOnVapour(data?.attachments);
      }

      const managerEmails = data?.email?.map(item => {
        return {
          id: item?.id,
          name: item?.label,
          email: item?.value
        };
      }) || [];

      const participantData = data?.participants?.map(participant => ({
        id: participant?.id,
        uuid: participant?.value,
        name: participant?.label
      })) || [];


      const workerData = data?.workers?.map(worker => ({
        id: worker?.id,
        uuid: worker?.value,
        name: worker?.label
      })) || [];

      const feedbackPayload = {
        name: data?.name,
        date: data?.date,
        subject: data?.subject,
        email: managerEmails,
        details: data?.details,
        type: "feedback",
        attachments: uploadedFiles,
        participants: participantData,
        workers: workerData,
        feedback_assessment: data?.status?.value || 'positive',
      };


      let res = await apiPostRequest("/sp/feedback/store", feedbackPayload);

      if (res?.status === 200) {
        toast.success(res?.data?.success || "Feedback submitted successfully!");
        reset({
          name: "",
          date: null,
          subject: "",
          email: [],
          details: null,
          attachments: [],
          workers: [],
          status: []
        });
setPage(1);
        fetchWithFilters();
        closeModal();
      }
    } catch {
        // console.error("");

    } finally {
      setIsSubmitting(false);
    }
  };

  const flipSort = (by) => {
    setSortBy(by);
    setSortDescending(!sortDescending);
    handleFetch({
      sort_field: by,
      sort_order: !sortDescending ? SORT_TYPE.DESC : SORT_TYPE.ASC,
    });
  };

  const onSubmit = (data = {}) => {
    if (isSubmitting || isUserGracePeriodOver) {
      return;
    }
    dataSubmitHandler(data);
  };

  const closeModal = () => {
    setisOpen(false);
    reset();
  };

  const openModal = () => {
    setisOpen(true);
  };

  const handleView = (feedback) => {
    setSelectedFeedback(feedback);
    setViewModalOpen(true);
  };

  const handleStatusUpdate = (feedbackUuid, newStatus, newCIPValue = null) => {
    setFeedbacks(prevFeedbacks => {
      if (prevFeedbacks?.data) {
        return {
          ...prevFeedbacks,
          data: prevFeedbacks.data.map(feedback => {
            if (feedback.uuid === feedbackUuid) {
              const updatedFeedback = { ...feedback };
              if (newStatus) {
                updatedFeedback.status = newStatus;
              }
              if (newCIPValue !== null) {
                updatedFeedback.continuous_improvement_plan = newCIPValue;
                updatedFeedback.cip = newCIPValue;
              }
              return updatedFeedback;
            }
            return feedback;
          })
        };
      }
      return prevFeedbacks;
    });

    setSelectedFeedback(prev => {
      if (prev?.uuid === feedbackUuid) {
        const updatedFeedback = { ...prev };
        if (newStatus) {
          updatedFeedback.status = newStatus;
        }
        if (newCIPValue !== null) {
          updatedFeedback.continuous_improvement_plan = newCIPValue;
          updatedFeedback.cip = newCIPValue;
        }
        return updatedFeedback;
      }
      return prev;
    });

    setTimeout(() => {
      refreshFeedbackList();
    }, 1000);
  };

  const handleDeleteClick = (feedback) => {
    setFeedbackToDelete(feedback);
    setDeleteModalOpen(true);
  };

  const handleEdit = (feedback) => {
    setFeedbackToEdit(feedback);
    setEditModalOpen(true);
  };

  const handleEditSuccess = () => {
    setEditModalOpen(false);
    setFeedbackToEdit(null);
    refreshFeedbackList();
  };

  const fetchWithFilters = (additionalFilters = {}, overrideFilters = {}) => {
    const payload = { page: additionalFilters.page || 1, ...additionalFilters };

    const currentStatus = overrideFilters.status !== undefined ? overrideFilters.status : selectedStatus;
    const currentParticipant = overrideFilters.participant !== undefined ? overrideFilters.participant : selectedParticipant;
    const currentManager = overrideFilters.manager !== undefined ? overrideFilters.manager : selectedManager;
        const currentWorker = overrideFilters.worker !== undefined ? overrideFilters.worker :selectedWorker;

    const currentFromDate = overrideFilters.fromDate !== undefined ? overrideFilters.fromDate : fromDate;
    const currentToDate = overrideFilters.toDate !== undefined ? overrideFilters.toDate : toDate;

    if (currentStatus && currentStatus.value) {
      payload.status = currentStatus.value;
    }

    if (currentParticipant && currentParticipant.value) {
      payload.participant_uuid = currentParticipant.value;
    }

    if (currentManager && currentManager.uuid) {
      payload.manager_uuid = currentManager.uuid;
    }
    if( currentWorker && currentWorker.value){
      payload.worker_uuid = currentWorker.value;
    }

    if (currentFromDate) {
      payload.date_from = moment(currentFromDate).format('YYYY-MM-DD');
    }

    if (currentToDate) {
      payload.date_to = moment(currentToDate).format('YYYY-MM-DD');
    }

    handleFetch(payload);
  };

  const handleStatusChange = (status) => {
    setSelectedStatus(status);
    fetchWithFilters({}, { status });
  };

  const handleParticipantChange = (participant) => {
    setSelectedParticipant(participant);
    fetchWithFilters({}, { participant });
  };

  const handleManagerChange = (manager) => {
    setSelectedManager(manager);
    fetchWithFilters({}, { manager });
  };
    const handleWorkerChange = (worker) => {
    setSelectedWorker(worker);
    fetchWithFilters({}, { worker });
  };

  const handleDateRangeChange = (obj) => {
    if (obj && obj.fromDate && obj.toDate) {
      setFromDate(obj.fromDate);
      setToDate(obj.toDate);
      fetchWithFilters({}, { fromDate: obj.fromDate, toDate: obj.toDate });
    }
  };

  const handleDateCancel = () => {
    setFromDate(null);
    setToDate(null);
    fetchWithFilters({}, { fromDate: null, toDate: null });
  };

  const handleDeleteConfirm = async () => {
    if (!feedbackToDelete) return;
    setIsDeleting(true);
    try {
      const response = await apiDeleteRequest(`${URL_FEEDBACK_DELETE}/${feedbackToDelete?.uuid}`);
      toast.success("Feedback deleted successfully!");
      fetchWithFilters();
      setDeleteModalOpen(false);
      setFeedbackToDelete(null);
    } catch (error) {
      toast.error("Failed to delete feedback");
    } finally {
      setIsDeleting(false);
    }
  };

  const refreshFeedbackList = async () => {
    fetchWithFilters();
  };

  const clearAllFilters = () => {
    setSelectedStatus(null);
    setSelectedParticipant(null);
    setSelectedManager(null);
    setSelectedWorker(null);
    setFromDate(null);
    setToDate(null);
    setSearch('');
    handleFetch({ page: 1 });
  };

  return (
    <div className='min-h-screen'>
      <SideBar />
      <main>
        <div
          className={`${
            sideBarPadding
              ? "lg:pl-[4rem] duration-300 flex flex-col"
              : "lg:pl-64 duration-300 flex flex-col"
          }`}
        >
          <Header
            title='Feedback'
            desc='Directory of all Feedback'
            handleClick={openModal}
            btnLabel='Feedback'
            icon={<AiOutlinePlus />}
            isButton
          />
          <div className="w-full mx-auto px-6 overflow-hidden min-h-full pb-12 ">
            <div className='min-w-full mx-auto '>
              <FeedbackFilters
                selectedStatus={selectedStatus}
                selectedParticipant={selectedParticipant}
                selectedManager={selectedManager}
                selectedWorker={selectedWorker}
                fromDate={fromDate}
                toDate={toDate}
                statusOptions={statusOptions}
                participantOptions={participantOptions}
                managerOptions={managerOptions}
                search={search}
                setSearch={setSearch}
                onStatusChange={handleStatusChange}
                onParticipantChange={handleParticipantChange}
                onManagerChange={handleManagerChange}
                handleWorkerChange={handleWorkerChange}
                onDateRangeChange={handleDateRangeChange}
                onDateCancel={handleDateCancel}
                onClearAllFilters={clearAllFilters}
                loadingParticipants={loadingParticipants}
                loadingManagers={loadingManagers}
                selectedFromDate={selectedFromDate}
                setSelectedFromDate={setSelectedFromDate}
                workersList={workersList}
                loadingWorkers={loadingWorkers}
              />
              <div className='bg-white min-w-full mx-auto  pt-4'>
                <div className='flex flex-col'>
                  <div className='-my-2 -mx-4 overflow-x-auto scrollbar-hide sm:-mx-6 lg:-mx-8'>
                    <div className='inline-block min-w-full py-2 align-middle md:px-6 lg:px-8'>
                      <FeedbackTable
                        loading={loading}
                        feedbacks={feedbacks}
                        sortBy={sortBy}
                        sortDescending={sortDescending}
                        flipSort={flipSort}
                        onView={handleView}
                        onEdit={handleEdit}
                        onDelete={handleDeleteClick}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {!(feedbacks?.data?.length === 0 || feedbacks.length === 0) && (
              <div className='bg-white  min-w-full mx-auto mt-2 pb-4'>
                <PaginationComponent
                  page={page}
                  activeListLength={feedbacks?.data || []}
                  limit={POLICIES_LIST_LIMIT}
                  totalList={feedbacks?.total || 0}
                  handlePagination={(e) => {
                    setPage(e);
                    const obj = paginationObj;
                    obj.page = e;
                    setPaginationObj({ ...obj });
                  }}
                  totalPages={feedbacks?.total_pages}
                />
              </div>
            )}

            <AddFeedbackModal
              isOpen={isOpen}
              closeModal={closeModal}
              onSubmit={onSubmit}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              control={control}
              setValue={setValue}
              watch={watch}
              isSubmitting={isSubmitting}
              isUserGracePeriodOver={isUserGracePeriodOver}
              loadingWorkers={loadingWorkers}
              workersList={workersList}
             participantsList= {participantOptions}
              managerList={managerOptions}
            loadingParticipants= {loadingParticipants}
loadingManagers={loadingManagers}
            />

            <EditFeedbackModal
              isOpen={editModalOpen}
              onClose={() => {
                setEditModalOpen(false);
                setFeedbackToEdit(null);
              }}
              feedbackToEdit={feedbackToEdit}
              onSuccess={handleEditSuccess}
              refreshFeedback={refreshFeedbackList}
            />

            <ViewFeedbackModal
              isOpen={viewModalOpen}
              closeModal={() => {
                setViewModalOpen(false);
                setSelectedFeedback(null);
              }}
              feedbackData={selectedFeedback}
              onStatusUpdate={handleStatusUpdate}
            />

            <DeleteFeedbackModal
              isOpen={deleteModalOpen}
              onClose={() => {
                setDeleteModalOpen(false);
                setFeedbackToDelete(null);
              }}
              onConfirm={handleDeleteConfirm}
              feedbackToDelete={feedbackToDelete}
              isDeleting={isDeleting}
            />
          </div>
        </div>
      </main>
    </div>
  );
};

export default Feedback;
